import { Cable } from '@mui/icons-material'
import { ApplianceConfigUnknownRelay } from './Appliance'
import { TemperatureRelayAppliance } from './TemperatureRelayAppliance'

export class UnknownRelayAppliance extends TemperatureRelayAppliance<ApplianceConfigUnknownRelay> {
  get Icon() {
    return Cable
  }

  getDefaultConfig(): ApplianceConfigUnknownRelay {
    return Object.assign({
      strategy: 'MANUAL',
      plan_by_price: true,
      pv_priority: 14,
    }, super.getDefaultConfig())
  }
}
